/**
 * SignatureListItem — Einzelner Listeneintrag fuer die Signatur-Profil-Verwaltung.
 *
 * Zeigt: Profil-Name (truncate) + Stern-Icon wenn Default + Optionen-Dropdown.
 * Aktiv: gelber Hintergrund (#E9FF57, schwarze Schrift #1A1A1A)
 * Inaktiv: hover:bg-gray-100
 */
import { useState } from 'react';
import { Star, MoreVertical } from 'lucide-react';
import type { SignatureProfile } from '../../types';

interface Props {
  profile: SignatureProfile;
  isActive: boolean;
  onSelect: () => void;
  onSetDefault: () => void;
  onDelete: () => void;
}

export function SignatureListItem({ profile, isActive, onSelect, onSetDefault, onDelete }: Props) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      data-profile-id={profile.id}
      className={`relative flex items-center gap-2 px-3 py-2 rounded cursor-pointer text-sm select-none
        ${isActive ? 'bg-[#E9FF57] text-[#1A1A1A] font-semibold' : 'text-[#1A1A1A] hover:bg-gray-100'}`}
      onClick={onSelect}
    >
      <span className="flex-1 truncate">{profile.name}</span>
      {profile.isDefault && (
        <Star className="w-3 h-3 shrink-0 text-[#1A1A1A]" fill="currentColor" aria-label="Default-Profil" />
      )}
      <button
        type="button"
        className="shrink-0 p-0.5 rounded hover:bg-black/10"
        onClick={(e) => { e.stopPropagation(); setMenuOpen((v) => !v); }}
        aria-label="Optionen"
      >
        <MoreVertical className="w-4 h-4" />
      </button>
      {menuOpen && (
        <div
          className="absolute right-0 top-8 z-20 w-48 bg-white border border-[#DAD9D9] rounded shadow-lg py-1"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            disabled={profile.isDefault}
            className="w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
            onClick={() => { setMenuOpen(false); onSetDefault(); }}
          >
            Als Default markieren
          </button>
          <button
            type="button"
            className="w-full text-left px-3 py-1.5 text-sm text-red-600 hover:bg-red-50"
            onClick={() => { setMenuOpen(false); onDelete(); }}
          >
            Loeschen
          </button>
        </div>
      )}
    </div>
  );
}
